import {
  DateSelectArg,
  DayHeaderContentArg,
  EventChangeArg,
  EventClickArg,
  EventContentArg,
} from "@fullcalendar/core";
import { createRef } from "@fullcalendar/core/preact";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import moment from "moment";
import { BlockUI } from "primereact/blockui";
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../auth/AuthContext";
import Card from "../../components/card/Card";
import FormDialog from "../../components/dialogs/form/FormDialog";
import { Loader } from "../../components/loader/Loader";
import { useToast } from "../../components/toast/Toast";
import { AreaTrabajoSelectModel } from "../../models/AreaTrabajoModel";
import { EnviarEmailModel } from "../../models/EnviarEmailModel";
import { EspacioModel } from "../../models/EspacioModel";
import { EventModel } from "../../models/EventModel";
import { ParticipanteModel } from "../../models/ParticipanteModel";
import {
  ReservacionFormModel,
  ReservacionModel,
  ReservacionParticipanteModel,
  createEventId,
} from "../../models/ReservacionModel";
import { ResponseModel } from "../../models/ResponseModel";
import { UsuarioModel } from "../../models/UsuarioModel";
import { getListaAreaTrabajoSelectService } from "../../services/AreaTrabajoService";
import { EnviarEmailService } from "../../services/EmailService";
import { getListaEspacioService } from "../../services/EspacioService";
import {
  removeParticipanteService,
  saveParticipanteService,
} from "../../services/ParticipanteService";
import {
  getListaReservacionService,
  removeReservacionService,
  saveReservacionFormService,
  saveReservacionParticipanteService,
  updateReservacionFormService,
  removeReservacionSoftService,
} from "../../services/ReservacionService";
import { getListaUsuarioService } from "../../services/UsuarioService";
import "./CalendarioDeOcupacion.scss";
import {
  isAdmin,
  validatePersonalCreate,
  validateRol,
} from "../../util/validationActions";

moment.locale("es-mx");

const CalendarioDeOcupacion = () => {
  // Calendar
  const calendarComponentRef = createRef();
  // Lista de Reservacion
  let [listaReservacion, setListaReservacion] = useState<ReservacionModel[]>(
    []
  );
  // Espacios
  const [listaEspacio, setListaEspacio] = useState<EspacioModel[]>([]);
  // Lista de Ususario
  const [listaUsuario, setListaUsuario] = useState<UsuarioModel[]>([]);
  // Lista de Area Trabajo Select
  const [listaAreaTrabajoSelect, setListaAreaTrabajoSelect] =
    useState<AreaTrabajoSelectModel[]>();
  // Lista de Evento para el calendario
  const [listaEvent, setListaEvent] = useState<EventModel[]>([]);
  const [visibleFormDialog, setVisibleFormDialog] = useState(false);
  const [isInfo, setIsInfo] = useState(false);
  const [reservacionForm, setReservacionForm] = useState<ReservacionFormModel>(
    {}
  );
  const [isLoader, setIsLoader] = useState(false);
  //const [isPropio, setIsPropio] = useState<boolean>(false);

  const { onToastSuccess, onToastError } = useToast();
  //const [calendarApi, setCalendarApi] = useState<CalendarApi>();

  const { loggedUser, rol } = useAuth();
  const { id } = loggedUser();

  let lis: any = [];

  /**
   * Obtiene y carga la lista de reservaciones desde el servicio
   */
  const getListaReservacion = async () => {
    await getListaReservacionService().then((response: ResponseModel) => {
      if (response.status === 200) {
        const _listaReservacion: ReservacionModel[] | undefined = [
          ...response.data,
        ];
        setListaReservacion(_listaReservacion);

        // Asignamos los datos para lista de evento
        let _listaEvento: EventModel[] = [];
        _listaReservacion.forEach((reservacion) => {
          // Agregamos el evento de calendario
          let eventModel: EventModel = new EventModel();
          eventModel.id = reservacion.id?.toString();
          eventModel.title = reservacion.titulo;
          eventModel.start = String(reservacion.fecha_inicio);
          eventModel.end = String(reservacion.fecha_fin);
          eventModel.espacio = reservacion?.espacio?.nombre;
          //eventModel.backgroundColor = 'white';
          //eventModel.borderColor = listaAreaTrabajoSelect?.find(at => {return at.usuarios?.find(u => u.id === reservacion.reservado_para?.id)})?.color;
          eventModel.extendedProps = {
            colorArea: listaAreaTrabajoSelect?.find((at) => {
              return at.usuarios?.find(
                (u) => u.id === reservacion.reservado_para?.id
              );
            })?.color,
            espacioId: reservacion.espacio?.id,
          };

          _listaEvento.push(eventModel);
          lis.push(reservacion);
        });
        setListaEvent(_listaEvento);
      } else {
        console.log(response.message);
        onToastError(
          "Error",
          "No se puede obtener lista del espacio, intente mas tarde."
        );
      }
    });
  };

  /**
   * Obtiene y carga la lista de espacios disponibles
   */
  const getListaEspacio = async () => {
    await getListaEspacioService(id).then((response: ResponseModel) => {
      if (response.status === 200) {
        setListaEspacio(response.data);
      } else {
        console.log(response.message);
        onToastError(
          "Error",
          "No se puede obtener lista del espacio, intente mas tarde."
        );
      }
    });
  };

  /**
   * Obtiene y carga la lista de usuarios
   */
  const getListaUsuario = async () => {
    await getListaUsuarioService().then((response: ResponseModel) => {
      if (response.status === 200) {
        setListaUsuario(response.data);
      } else {
        console.log(response.message);
        console.log(listaUsuario);
        onToastError(
          "Error",
          "No se puede obtener lista del Usuario, intente mas tarde."
        );
      }
    });
  };

  /**
   * Obtiene y carga la lista de áreas de trabajo
   */
  const getListaAreaTrabajoSelect = async () => {
    await getListaAreaTrabajoSelectService().then((response: ResponseModel) => {
      if (response.status === 200) {
        setListaAreaTrabajoSelect(response.data);
      } else {
        console.log(response.message);
        onToastError(
          "Error",
          "No se puede obtener lista del Area Trabajo, intente mas tarde."
        );
      }
    });
  };

  // Listas
  useEffect(() => {
    //getListaReservacion();
    getListaEspacio();
    getListaUsuario();
    getListaAreaTrabajoSelect();
    // eslint-disable-next-line
  }, []);

  // Cuando terminar carga de lista de Area Trabajo para que se cargue lista de reservacion.
  useEffect(() => {
    if (listaAreaTrabajoSelect) {
      getListaReservacion();
    }
    // eslint-disable-next-line
  }, [listaAreaTrabajoSelect]);

  // Ciclo de vida (lista de reservación)
  useEffect(() => {
    let isMounted = true;
    let timeoutId: NodeJS.Timeout;
    let lastUpdate = Date.now();

    const updateReservations = async () => {
      if (!isMounted) return;

      // Verificar si ha pasado suficiente tiempo desde la última actualización
      const now = Date.now();
      if (now - lastUpdate < 30000) {
        timeoutId = setTimeout(updateReservations, 30000);
        return;
      }

      try {
        await lifecycleListaReservacion();
        lastUpdate = now;
      } catch (error) {
        console.error("Error updating reservations:", error);
      }

      // Programar la siguiente actualización
      timeoutId = setTimeout(updateReservations, 30000);
    };

    // Iniciar la primera actualización
    updateReservations();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [listaReservacion]);

  /**
   * Sincroniza el estado local de reservaciones con el servidor
   * Detecta nuevas, eliminadas y actualizadas
   */
  const lifecycleListaReservacion = async () => {
    await getListaReservacionService().then((response: ResponseModel) => {
      if (response.status === 200) {
        const _listaReservacion: ReservacionModel[] = [...response.data];

        // Obtenemos el ID de las reservaciones
        const listaReservacionId: any[] = Array.from(
          listaReservacion.map((r) => r.id)
        ) as any;

        // Obtenemos si reservacion es nueva para agregar en lista de reservacion
        const nuevaListaReservacion = _listaReservacion.filter(
          (r) => !listaReservacionId.includes(r.id)
        );
        if (nuevaListaReservacion.length > 0) {
          setListaReservacion((r) => [...r, ...nuevaListaReservacion]);

          nuevaListaReservacion.forEach((reservacion) => {
            // Agregamos el evento de calendario
            let nuevoEventModel: EventModel = new EventModel();
            nuevoEventModel.id = reservacion.id?.toString();
            nuevoEventModel.title = reservacion.titulo;
            nuevoEventModel.start = String(reservacion.fecha_inicio);
            nuevoEventModel.end = String(reservacion.fecha_fin);
            nuevoEventModel.espacio = reservacion?.espacio?.nombre;
            nuevoEventModel.extendedProps = {
              colorArea: listaAreaTrabajoSelect?.find((at) => {
                return at.usuarios?.find(
                  (u) => u.id === reservacion.reservado_para?.id
                );
              })?.color,
              espacioId: reservacion.espacio?.id,
            };

            setListaEvent((e) => [...e, nuevoEventModel]);
          });
        }

        // Obtenemos si la reservacion es borrado o no existe para eliminarlo
        const eliminaListaReservacion = listaReservacion.filter(
          (r) =>
            !_listaReservacion
              .map((_r) => {
                return _r.id;
              })
              .includes(r.id)
        );
        if (eliminaListaReservacion.length > 0) {
          // Eliminamos la reservacion
          let updateListaReservacion = [...listaReservacion].filter(
            (r) =>
              !eliminaListaReservacion
                .map((_r) => {
                  return _r.id;
                })
                .includes(r.id)
          );
          setListaReservacion(updateListaReservacion);
          // Eliminamos la reservacion
          let updateListaEvent = [...listaEvent].filter(
            (e) =>
              !eliminaListaReservacion
                .map((_r) => {
                  return _r.id?.toString();
                })
                .includes(e.id)
          );
          setListaEvent(updateListaEvent);
        }

        // Obtener si hay cambio de la reservacion para agregar en lista de reservacion como orden
        const actualizaListaReservacion = _listaReservacion.filter((r) => {
          const existingReservacion = listaReservacion.find(
            (_r) => r.id === _r.id
          );
          if (!existingReservacion) return false;

          // Compare participants by their IDs to avoid circular references
          const participantsChanged =
            r.participantes?.length !==
              existingReservacion.participantes?.length ||
            r.participantes?.some(
              (p, index) =>
                p.participante?.id !==
                existingReservacion.participantes?.[index]?.participante?.id
            );

          return (
            r.titulo !== existingReservacion.titulo ||
            r.descripcion !== existingReservacion.descripcion ||
            r.reservado_para?.id !== existingReservacion.reservado_para?.id ||
            participantsChanged ||
            moment(r.fecha_inicio).format("x") !==
              moment(existingReservacion.fecha_inicio).format("x") ||
            moment(r.fecha_fin).format("x") !==
              moment(existingReservacion.fecha_fin).format("x")
          );
        });
        if (actualizaListaReservacion.length > 0) {
          // Obtenemos lista de reservacion
          let _actualizaListaReservacion: ReservacionModel[] = [
            ...listaReservacion,
          ];
          // Obtenemos lista de evento
          let actualizaListaEvent: EventModel[] = [...listaEvent];
          actualizaListaReservacion.forEach((r) => {
            // Actualizamos la reservacion en lista
            let indexReservacion: number = listaReservacion.findIndex(
                (_r) => _r.id === r.id
              ),
              actualizaReservacion = {
                ..._actualizaListaReservacion[indexReservacion],
              };

            // Actualizamos la reservacion (obtener y establecer los datos del formulario)
            actualizaReservacion.espacio = listaEspacio.find(
              (espacio) => espacio.id === r.espacio?.id
            );
            actualizaReservacion.titulo = r.titulo;
            actualizaReservacion.descripcion = r.descripcion;
            actualizaReservacion.reservado_para = r.reservado_para;
            actualizaReservacion.reservado_por = r.reservado_por;
            actualizaReservacion.participantes = r.participantes;
            actualizaReservacion.fecha_inicio = r.fecha_inicio;
            actualizaReservacion.fecha_fin = r.fecha_fin;

            _actualizaListaReservacion[indexReservacion] = {
              ...actualizaReservacion,
            };
            setListaReservacion([..._actualizaListaReservacion]);

            // Actualizamos el evento para el calendario
            let indexEvent = actualizaListaEvent.findIndex(
                (e) => e.id === r.id?.toString()
              ),
              actualizaEventModel: EventModel = {
                ...actualizaListaEvent[indexEvent],
              };
            actualizaEventModel.id = r.id?.toString();
            actualizaEventModel.title = r.titulo;
            actualizaEventModel.espacio = r.espacio?.nombre;
            actualizaEventModel.start = r.fecha_inicio as any;
            actualizaEventModel.end = r.fecha_fin as any;
            actualizaEventModel.extendedProps = {
              colorArea: listaAreaTrabajoSelect?.find((at) => {
                return at.usuarios?.find(
                  (u) => u.id === actualizaReservacion.reservado_para?.id
                );
              })?.color,
              espacioId: actualizaReservacion.espacio?.id,
            };

            // Actualizamos el evento para calendario
            actualizaListaEvent[indexEvent] = { ...actualizaEventModel };
            setListaEvent([...actualizaListaEvent]);
          });
        }
      }
    });
  };

  /**
   * Maneja la selección de fecha/hora en el calendario para crear nueva reservación
   * @param {DateSelectArg} selectInfo - Información de la selección
   */
  const onSelect = (selectInfo: DateSelectArg) => {
    if (selectInfo.view.type !== "dayGridMonth") {
      const fechaStart: string = moment(selectInfo.start).format("L"),
        fechaEnd: string = moment(selectInfo.end).format("L");

      let calendarApi = selectInfo.view.calendar;

      // Verificar si la selección excede 1.5 horas (90 minutos)
      const duracionMinutos = moment(selectInfo.end).diff(
        moment(selectInfo.start),
        "minutes"
      );
      if (duracionMinutos > 90 && !isAdmin()) {
        calendarApi?.unselect();
        onToastError(
          "Error",
          "La reservación no puede exceder 1 hora y 30 minutos."
        );
        return;
      }

      // Verificar si la fecha es terminado
      if (onVerificarTerminaFecha(selectInfo.end)) {
        calendarApi?.unselect();
        return;
      }

      // No se puede crear o cambiar de la fecha antes de la fecha actual
      if (onVerificarFechaAnterior(selectInfo.start)) {
        calendarApi?.unselect();
        onToastError(
          "Error",
          "No se puede ingresar una fecha anterior a la actual."
        );
        return;
      }

      if (fechaStart === fechaEnd) {
        let reservacion: ReservacionModel = new ReservacionModel();
        reservacion.id = createEventId();
        reservacion.espacio = null as any;
        reservacion.fecha_inicio = selectInfo.start;
        reservacion.fecha_fin = selectInfo.end;
        reservacion.reservado_por = new UsuarioModel(loggedUser());

        setReservacionForm(reservacion as any);
        setIsInfo(false);
        setVisibleFormDialog(true);
      } else {
        calendarApi?.unselect();
        return;
      }
    }
  };

  /**
   * Renderiza el contenido personalizado de cada evento en el calendario
   * @param {EventContentArg} event - Datos del evento a renderizar
   * @returns {JSX.Element} Componente Card con la información del evento
   */
  const eventContent = useCallback(
    (event: EventContentArg) => {
      const reservacion = listaReservacion.find(
        (r) => r.id === parseInt(event.event.id)
      );
      const eventData = {
        title: event.event.title,
        // timeStart: "10:00",
        // timeEnd: "11:00",
        timeText:
          event.event.start && event.event.end
            ? moment(event.event.start).format("h:mm") +
              " - " +
              moment(event.event.end).format("h:mm")
            : "",
        espacio: reservacion?.espacio?.nombre,
        colorArea: event.event.extendedProps?.colorArea || "#e8474fc7",
        reservadoPor: reservacion?.reservado_por?.nombre,
        reservadoPara: reservacion?.reservado_para?.nombre,
        descripcion: reservacion?.descripcion,
      };

      return <Card event={eventData} />;
    },
    [listaReservacion]
  );

  /**
   * Maneja el cambio de posición/duración de un evento (arrastrar y redimensionar)
   * @param {EventChangeArg} event - Información del cambio del evento
   */
  const onEventChange = (event: EventChangeArg) => {
    if (event) {
      // Mostramos Loader
      setIsLoader(true);

      // Verificar si la fecha es terminado
      if (onVerificarTerminaFecha(event.event.end)) {
        // Ocultamos Loader
        setIsLoader(false);
        // Regresa su lugar de evento
        onRegresaEvent(
          event.event.id,
          event.oldEvent.startStr,
          event.oldEvent.endStr
        );
        return;
      }

      // Verificar si las fechas y espacio son la misma no se puede aplicar
      if (
        onVerificarFechas(
          event.event.start,
          event.event.end,
          event.event.id,
          event.event.extendedProps.espacioId
        )
      ) {
        // Ocultamos Loader
        setIsLoader(false);
        // Regresa su lugar de evento
        onRegresaEvent(
          event.event.id,
          event.oldEvent.startStr,
          event.oldEvent.endStr
        );
        return;
      }

      const reservacion: ReservacionModel = {
        ...listaReservacion.find((r) => r.id === parseInt(event.event.id)),
      };

      // Verificar si el evento es propio para que puede mover o editar
      if (onVerificarEsPropio(reservacion)) {
        // No se puede crear o cambiar de la fecha antes de la fecha actual
        if (onVerificarFechaAnterior(event.event.start)) {
          // Ocultamos Loader
          setIsLoader(false);

          onToastError(
            "Error",
            "No se puede ingresar una fecha anterior a la actual."
          );
          onRegresaEvent(
            event.event.id,
            event.oldEvent.startStr,
            event.oldEvent.endStr
          );
          return;
        }

        let reservacionForm: ReservacionFormModel = reservacion as any;
        reservacionForm.espacio = reservacion.espacio?.id;
        reservacionForm.fecha_inicio = event.event.start;
        reservacionForm.fecha_fin = event.event.end;

        updateReservacionFormService(reservacionForm).then(
          (response: ResponseModel) => {
            if (response.status === 200) {
              onToastSuccess("Correcto", "Ha actualizado la reservación.");

              let enviarEmail: EnviarEmailModel = new EnviarEmailModel(
                reservacionForm
              );
              enviarEmail.espacio = listaEspacio.find(
                (espacio) => espacio.id === reservacionForm.espacio
              );

              // Enviar email para la invitación
              let actualizaEnviarEmail: EnviarEmailModel = new EnviarEmailModel(
                enviarEmail
              );
              actualizaEnviarEmail.method = "REQUEST";

              // onEnviarEmail(actualizaEnviarEmail);
              setIsLoader(false);
            } else {
              // Ocultamos Loader
              setIsLoader(false);

              console.log(response.message);
              onToastError(
                "Error",
                "No se puede guardar los participantes, intente mas tarde."
              );
            }
          }
        );
      } else {
        // Regresa su lugar de evento
        onRegresaEvent(
          event.event.id,
          event.oldEvent.startStr,
          event.oldEvent.endStr
        );
      }
    }
  };

  /**
   * Revierte un evento a su posición original en el calendario
   * @param {string} id - ID del evento
   * @param {string} start - Fecha/hora de inicio original
   * @param {string} end - Fecha/hora de fin original
   */
  const onRegresaEvent = (id: string, start: string, end: string): void => {
    // Actualizamos el evento para el calendario
    let actualizaListaEvent: EventModel[] = [...listaEvent],
      indexEvent = listaEvent.findIndex((e) => e.id === id);
    let actualizaEventModel: EventModel = {
      ...actualizaListaEvent[indexEvent],
    };
    actualizaEventModel.start = start;
    actualizaEventModel.end = end;

    // Actualizamos el evento para calendario
    actualizaListaEvent[indexEvent] = { ...actualizaEventModel };
    setListaEvent(actualizaListaEvent);
  };

  /**
   * Guarda o actualiza una reservación con sus participantes
   * @param {ReservacionFormModel} reservacionForm - Datos del formulario de reservación
   */
  const onClickGuardaReservacion = (
    reservacionForm: ReservacionFormModel
  ): void => {
    // Verificar si la fecha es terminado
    if (onVerificarTerminaFecha(reservacionForm.fecha_fin)) {
      onToastError(
        "Error",
        "No se puede ingresar una fecha anterior a la actual."
      );
      return;
    }

    if (
      onVerificarFechas(
        reservacionForm.fecha_inicio,
        reservacionForm.fecha_fin,
        reservacionForm.id as any,
        reservacionForm.espacio as any
      )
    ) {
      // Mostramos Loader
      setIsLoader(false);
      onToastError(
        "Error",
        "El espacio se encuentro ocupado, eliges otro por favor."
      );
      return;
    }

    // Mostramos Loader
    setIsLoader(true);

    if (isInfo) {
      const listaParticipanteUsuario: UsuarioModel[] =
        reservacionForm.participantes
          ? [...(reservacionForm.participantes as any)]
          : [];

      //Eliminamos los objetos de la reservacion para poder actualizarlo
      delete reservacionForm.participantes;

      updateReservacionFormService(reservacionForm).then(
        (response: ResponseModel) => {
          if (response.status === 200) {
            onToastSuccess("Correcto", "Ha actualizado la reservación.");

            // Actualizamos la reservacion en lista
            let actualizaListaReservacion: ReservacionModel[] = [
                ...listaReservacion,
              ],
              indexReservacion = listaReservacion.findIndex(
                (r) => r.id === reservacionForm.id
              ),
              actualizaReservacion = {
                ...actualizaListaReservacion[indexReservacion],
              };

            // Verificar los participantes son nuevos para guardar
            listaParticipanteUsuario?.forEach((participante) => {
              if (
                !actualizaReservacion.participantes?.some(
                  (_participante) =>
                    _participante.participante?.id === participante.id
                )
              ) {
                let nuevoParticipante: ParticipanteModel =
                  new ParticipanteModel();
                delete nuevoParticipante.id;
                nuevoParticipante.participante = participante;
                nuevoParticipante.reservacion = actualizaReservacion;

                // Enviar api para guardar (nuevo participante);
                if (!nuevoParticipante) return;
                saveParticipanteService(nuevoParticipante).then(
                  (responseRP: ResponseModel) => {
                    if (responseRP.status === 200) {
                      let _nuevoParticipante: ParticipanteModel =
                        new ParticipanteModel(nuevoParticipante);
                      _nuevoParticipante.id = responseRP.data.id;

                      actualizaReservacion.participantes?.push(
                        _nuevoParticipante
                      );
                    }
                  }
                );
              }
            });

            // Verificar los participantes son que no estan para eliminar
            if (actualizaReservacion.participantes) {
              actualizaReservacion.participantes?.forEach((participante) => {
                if (
                  !listaParticipanteUsuario?.some(
                    (_participante) =>
                      _participante.id === participante.participante?.id
                  )
                ) {
                  // Enviar api para eliminar
                  removeParticipanteService(participante.id as any);

                  // Actualizamos la reservacion que estaba eliminado de participante
                  actualizaReservacion.participantes =
                    actualizaReservacion.participantes?.filter(
                      (p) => p.id !== participante.id
                    );
                }
              });
            }

            // Actualizamos la reservacion (obtener y establecer los datos del formulario)
            actualizaReservacion.espacio = listaEspacio.find(
              (espacio) => espacio.id === reservacionForm.espacio
            );
            actualizaReservacion.titulo = reservacionForm.titulo;
            actualizaReservacion.descripcion = reservacionForm.descripcion;
            actualizaReservacion.reservado_para =
              reservacionForm.reservado_para;
            actualizaReservacion.reservado_por = reservacionForm.reservado_por;
            actualizaReservacion.fecha_inicio = reservacionForm.fecha_inicio;
            actualizaReservacion.fecha_fin = reservacionForm.fecha_fin;

            actualizaListaReservacion[indexReservacion] = {
              ...actualizaReservacion,
            };
            setListaReservacion(actualizaListaReservacion);

            // Actualizamos el evento para el calendario
            let actualizaListaEvent: EventModel[] = [...listaEvent],
              indexEvent = listaEvent.findIndex(
                (e) => e.id === reservacionForm.id?.toString()
              );
            let actualizaEventModel: EventModel = new EventModel();

            actualizaEventModel.id = reservacionForm.id?.toString();
            actualizaEventModel.title = reservacionForm.titulo;
            actualizaEventModel.start =
              reservacionForm.fecha_inicio?.toISOString();
            actualizaEventModel.end = reservacionForm.fecha_fin?.toISOString();
            actualizaEventModel.espacio = listaEspacio.find(
              (espacio) => espacio.id === reservacionForm.espacio
            )?.nombre;
            actualizaEventModel.extendedProps = {
              colorArea: listaAreaTrabajoSelect?.find((at) => {
                return at.usuarios?.find(
                  (u) => u.id === actualizaReservacion.reservado_para?.id
                );
              })?.color,
              espacioId: reservacionForm.espacio,
            };

            // Actualizamos el evento para calendario
            actualizaListaEvent[indexEvent] = { ...actualizaEventModel };
            setListaEvent(actualizaListaEvent);

            // Enviar email para la invitación
            let actualizaEnviarEmail: EnviarEmailModel = new EnviarEmailModel(
              actualizaReservacion
            );
            actualizaEnviarEmail.method = "REQUEST";
            actualizaEnviarEmail.isCreated = false;

            // onEnviarEmail(actualizaEnviarEmail);

            setVisibleFormDialog(false);

            setIsLoader(false);
          } else {
            console.log(response.message);
            onToastError(
              "Error",
              "No se puede acutalizar la reservación, intente mas tarde."
            );

            //Loader
            setIsLoader(false);
            setVisibleFormDialog(false);
          }
        }
      );
    } else {
      const listaParticipanteUsuario: UsuarioModel[] = [
        ...(reservacionForm.participantes as any),
      ];

      // Eliminamos el objeto ID para poder guardar
      delete reservacionForm.id;
      delete reservacionForm.participantes;

      saveReservacionFormService(reservacionForm as any).then(
        (response: ResponseModel) => {
          if (response.status === 200) {
            // Asignamos el ID de reservacion (regresa)
            reservacionForm.id = response.data.id;

            let nuevoReservacionParticipante: ReservacionParticipanteModel =
              new ReservacionParticipanteModel();
            nuevoReservacionParticipante.id = response.data.id;

            listaParticipanteUsuario?.forEach((participante) =>
              nuevoReservacionParticipante.participantes?.push(participante)
            );

            saveReservacionParticipanteService(
              nuevoReservacionParticipante
            ).then((responseRP: ResponseModel) => {
              if (responseRP.status === 200) {
                onToastSuccess("Correcto", "Ha guardando la reservación.");

                let reservacion: ReservacionModel = new ReservacionModel(
                  reservacionForm
                );
                reservacion.espacio = listaEspacio.find(
                  (espacio) => espacio.id === reservacionForm.espacio
                );
                reservacion.participantes = [];

                // Asignamos los participantes (nuevo)
                listaParticipanteUsuario?.forEach(
                  (usuario: UsuarioModel, index: number) => {
                    let participante: ParticipanteModel =
                      new ParticipanteModel();
                    participante.id = responseRP.data[index].id;
                    participante.participante = usuario;

                    reservacion.participantes?.push(participante);
                  }
                );

                // Agregamos la reservacion en lista
                setListaReservacion((r) => [...r, reservacion]);

                // Agregamos el evento de calendario
                let nuevoEventModel: EventModel = new EventModel();
                nuevoEventModel.id = reservacionForm.id?.toString();
                nuevoEventModel.title = reservacionForm.titulo;
                nuevoEventModel.espacio = reservacion?.espacio?.nombre;
                nuevoEventModel.start =
                  reservacionForm.fecha_inicio?.toISOString();
                nuevoEventModel.end = reservacionForm.fecha_fin?.toISOString();
                //nuevoEventModel.backgroundColor = 'white';
                //nuevoEventModel.borderColor = listaAreaTrabajoSelect?.find(at => {return at.usuarios?.find(u => u.id === reservacion.reservado_para?.id)})?.color;
                nuevoEventModel.extendedProps = {
                  colorArea: listaAreaTrabajoSelect?.find((at) => {
                    return at.usuarios?.find(
                      (u) => u.id === reservacion.reservado_para?.id
                    );
                  })?.color,
                  espacioId: reservacionForm.espacio,
                };
                // Agregamos el evento para calendario
                setListaEvent((e) => [...e, nuevoEventModel]);

                // Enviar email para la invitación
                let nuevoEnviarEmail: EnviarEmailModel = new EnviarEmailModel(
                  reservacion
                );
                nuevoEnviarEmail.method = "REQUEST";
                nuevoEnviarEmail.isCreated = true;

                //TODO: DESCOMENTAR LINEA DE ABAJO PARA ENVIAR CORREO CUANDO ESTE CONECTADO Y LISTO
                // onEnviarEmail(nuevoEnviarEmail);
                setIsLoader(false);

                // Cerramos el dialog de formulario
                setVisibleFormDialog(false);
              } else {
                // Ocultammos Loader
                setIsLoader(false);
                setVisibleFormDialog(false);

                console.log(response.message);
                onToastError(
                  "Error",
                  "No se puede guardar los participantes, intente mas tarde."
                );
              }
            });
          } else {
            console.log(response.message);
            onToastError(
              "Error",
              "No se puede guardar la reservación, intente mas tarde."
            );

            setIsLoader(false);
            setVisibleFormDialog(false);
          }
        }
      );
    }
  };

  /**
   * Envía notificación por correo sobre la reservación
   * @param {EnviarEmailModel} enviarEmail - Datos del email a enviar
   */
  const onEnviarEmail = (enviarEmail: EnviarEmailModel) => {
    EnviarEmailService(enviarEmail).then((response) => {
      if (response.status === 200) {
        // Toast
        onToastSuccess(
          "Correos",
          (enviarEmail.participantes?.length as any) > 1
            ? "Han enviado correcto."
            : "Ha enviado correcto."
        );
      } else {
        // Toast
        onToastError("Error", response.data as any);
      }

      //Loader
      setIsLoader(false);
    });
  };

  /**
   * Elimina una reservación de forma lógica (soft delete)
   * @param {number} idReservacion - ID de la reservación a eliminar
   */
  const onConfirmRemoveSoft = (idReservacion: number) => {
    setIsLoader(true);

    const reservacion = {
      ...listaReservacion.find((r) => r.id === idReservacion),
    };

    const data = { updated_by: id };

    removeReservacionSoftService(idReservacion, data).then(
      (response: ResponseModel) => {
        if (response.status === 200) {
          onToastSuccess("Correcto", "Ha eliminado la reservación.");
        } else {
          onToastError(
            "Error",
            "No se puede eliminar la reservación, intente más tarde."
          );
          setIsLoader(false);
          return;
        }

        setVisibleFormDialog(false);

        let updateListaReservacion = [...listaReservacion].filter(
          (r) => r.id !== idReservacion
        );
        setListaReservacion(updateListaReservacion);

        let updateListaEvent = [...listaEvent].filter(
          (e) => e.id !== idReservacion.toString()
        );
        setListaEvent(updateListaEvent);

        let eliminaEnviarEmail: EnviarEmailModel = new EnviarEmailModel(
          reservacion
        );
        eliminaEnviarEmail.method = "CANCEL";
        eliminaEnviarEmail.isCreated = false;
        eliminaEnviarEmail.descripcion = "Se canceló";

        setIsLoader(false);
      }
    );
  };

  /**
   * Elimina una reservación y sus participantes
   * @deprecated Esta función está deprecada
   * @param {number} id - ID de la reservación a eliminar
   */
  const onConfirmRemove = (id: number) => {
    // Mostaramos Loader
    setIsLoader(true);

    const reservacion = { ...listaReservacion.find((r) => r.id === id) };

    // Primero eliminamos los participantes
    reservacion.participantes?.forEach((participante) => {
      removeParticipanteService(participante.id as any);
    });

    // Ahora eliminamos la reservación
    removeReservacionService(reservacion.id as any).then(
      (response: ResponseModel) => {
        if (response.status === 200) {
          onToastSuccess("Correcto", "Ha eliminado la reservación.");
        } else {
          console.log(response.message);
          onToastError(
            "Error",
            "No se puede eliminar la reservación, intente mas tarde."
          );
        }

        // Cerramos el dialogo del formulario
        setVisibleFormDialog(false);
        // Ocultamos Loader
        //setIsLoader(false);

        // Eliminamos la reservacion
        let updateListaReservacion = [...listaReservacion].filter(
          (r) => r.id !== id
        );
        setListaReservacion(updateListaReservacion);
        // Eliminamos la reservacion
        let updateListaEvent = [...listaEvent].filter(
          (e) => e.id !== id.toString()
        );
        setListaEvent(updateListaEvent);

        // Enviar email para la invitación
        let eliminaEnviarEmail: EnviarEmailModel = new EnviarEmailModel(
          reservacion
        );
        eliminaEnviarEmail.method = "CANCEL";
        eliminaEnviarEmail.isCreated = false;
        eliminaEnviarEmail.descripcion = "Se cancelo";

        // onEnviarEmail(eliminaEnviarEmail);
        setIsLoader(false);
      }
    );
  };

  /**
   * Renderiza el encabezado personalizado de cada día en el calendario
   * @param {DayHeaderContentArg} event - Información del encabezado del día
   * @returns {JSX.Element} Elemento del encabezado
   */
  const onDayHeaderContent = (event: DayHeaderContentArg) => {
    return <div className="imj-color-title">{event.text}</div>;
    // if(event.view.type === 'dayGridMonth'){
    //     return (
    //         <div className='imj-color-title'>
    //             {event.text}
    //         </div>
    //     )
    // }else{
    //     return (
    //         <div>
    //             {event.text}
    //         </div>
    //     )
    // }
  };

  /**
   * Cambia la vista del calendario a semana
   */
  const onClickTimeGridWeek = () => {
    // Asignamos la vista de TimeGridWeek
    calendarComponentRef.current.getApi().changeView("timeGridWeek");

    updateHeightRows();

    // Asignamos la vista de TimeGridWeek
    calendarComponentRef.current.getApi().changeView("timeGridWeek");
  };

  /**
   * Cambia la vista del calendario a día
   */
  const onClickTimeGridDay = () => {
    // Asignamos la vista de TimeGridDay
    calendarComponentRef.current.getApi().changeView("timeGridDay");

    updateHeightRows();

    // Asignamos la vista de TimeGridDay
    calendarComponentRef.current.getApi().changeView("timeGridDay");
  };

  /**
   * Ajusta dinámicamente la altura de las filas del calendario
   */
  const updateHeightRows = (): void => {
    var totalRows: number = 19,
      getHeight: number = document.getElementsByClassName(
        "fc-scrollgrid-section-body"
      )[0].clientHeight,
      dHeight = getHeight / totalRows,
      ultimoHeight = dHeight;

    if (dHeight * totalRows > getHeight) {
      ultimoHeight = dHeight - (dHeight * totalRows - getHeight);
    } else {
      ultimoHeight = ultimoHeight -= 0.4;
    }

    var rowsTimeGrid = document.getElementsByClassName("fc-timegrid-slot");

    for (let i = 0; i < rowsTimeGrid.length; i++) {
      if (i === totalRows - 1)
        (rowsTimeGrid[i] as any).style.height = dHeight + "px";
      else (rowsTimeGrid[i] as any).style.height = ultimoHeight + "px";
    }
  };

  /**
   * Maneja el clic en una fecha del calendario (vista mensual)
   * @param {DateClickArg} event - Información de la fecha clicada
   */
  const onDateClick = (event: DateClickArg) => {
    if (event.view.type === "dayGridMonth") {
      // Obtener el día de la semana (0 = domingo, 6 = sábado)
      const dayOfWeek = moment(event.date).day();

      // Verificar si la fecha es anterior a hoy
      const isBeforeToday = moment(event.date).isBefore(moment(), "day");

      // Solo permitir cambiar a vista de día si:
      // 1. No es sábado (6) ni domingo (0)
      // 2. No es un día anterior a hoy
      if (dayOfWeek !== 0 && dayOfWeek !== 6 && !isBeforeToday) {
        var viewDay = calendarComponentRef.current.getApi();
        viewDay.changeView("timeGridDay", event.dateStr);
        updateHeightRows();
      }
    }
  };

  /**
   * Verifica si el usuario actual puede editar la reservación
   * @param {ReservacionModel} reservacion - Reservación a verificar
   * @returns {boolean} True si puede editar
   */
  const onVerificarEsPropio = (reservacion: ReservacionModel): boolean => {
    const user: UsuarioModel = loggedUser();
    return (
      reservacion.reservado_por?.id === user.id ||
      rol.type === "administrador" ||
      rol.type === "management"
    );
  };

  /**
   * Verifica si existe un conflicto de horarios en el mismo espacio
   * @param {any} start - Fecha/hora de inicio
   * @param {any} end - Fecha/hora de fin
   * @param {string} reservacionId - ID de la reservación (opcional)
   * @param {number} espacioId - ID del espacio (opcional)
   * @returns {boolean} True si hay conflicto
   */
  const onVerificarFechas = (
    start: any,
    end: any,
    reservacionId?: string,
    espacioId?: number
  ): boolean => {
    // Obtenemos la lista de evento solo la fehca de hoy
    const _listaEvent = listaEvent.filter(
      (e) => moment(e.start).format("L") === moment(start).format("L")
    );

    return _listaEvent.some(
      (e) =>
        ((moment(start).format("x") >= moment(e.start).format("x") &&
          moment(start).format("x") < moment(e.end).format("x")) ||
          (moment(end).format("x") > moment(e.start).format("x") &&
            moment(end).format("x") <= moment(e.end).format("x")) ||
          (moment(start).format("x") < moment(e.start).format("x") &&
            moment(end).format("x") > moment(e.end).format("x"))) &&
        e.extendedProps.espacioId === espacioId &&
        e.id !== reservacionId?.toString()
    );
  };

  /**
   * Verifica si la fecha es anterior a la fecha actual
   * @param {any} start - Fecha/hora a verificar
   * @returns {boolean} True si es anterior
   */
  const onVerificarFechaAnterior = (start: any): boolean => {
    const fechaActual = moment().add(-1, "days").format("X");
    // No se puede crear o cambiar de la fecha antes de la fecha actual
    return fechaActual > moment(start).format("x");
  };

  /**
   * Verifica si la fecha de fin ya ha pasado
   * @param {any} end - Fecha/hora de fin a verificar
   * @returns {boolean} True si ya terminó
   */
  const onVerificarTerminaFecha = (end: any): boolean => {
    return moment().format("x") > moment(end).format("x");
  };

  /**
   * Valida si el usuario puede crear reservaciones
   * @returns {boolean} True si puede crear
   */
  const validationCreate = () => {
    return validatePersonalCreate() || validateRol();
  };
  /**
   * Valida si el usuario puede editar reservaciones
   * @returns {boolean} True si puede editar
   */
  const validateBtnEditar = () => {
    if (validateRol() || validatePersonalCreate()) return true;
    return false;
  };

  /**
   * Valida la duración de la selección de tiempo (máx 90 min para no admin)
   * @param {any} selectInfo - Información de la selección
   * @returns {boolean} True si la selección es válida
   */
  const validateTimeSelection = useCallback((selectInfo: any) => {
    //SI SON ADMINISTRADORES PUEDEN CREAR CUALQUIER DURACION
    if (isAdmin()) {
      return true; // Permitir cualquier duración para administradores
    }

    // Validar duración máxima de 90 minutos
    const duration = moment(selectInfo.end).diff(
      moment(selectInfo.start),
      "minutes"
    );

    // Validar que la hora de inicio no sea anterior a la hora actual
    const now = moment();
    const startTime = moment(selectInfo.start);

    // Si la fecha de inicio es anterior a la hora actual, no permitir la selección
    if (startTime.isBefore(now)) {
      return false;
    }

    return duration <= 90;
  }, []);

  /**
   * Maneja el clic en un evento del calendario
   * @param {EventClickArg} info - Información del evento clicado
   */
  const handleEventClick = useCallback(
    (info: EventClickArg) => {
      const reservacion: ReservacionModel | undefined = listaReservacion.find(
        (r) => r.id === parseInt(info.event.id)
      );
      if (!reservacion) return;

      let reservacionForm: ReservacionFormModel = { ...(reservacion as any) };
      reservacionForm.espacio = reservacion?.espacio?.id;
      reservacionForm.participantes = reservacion?.participantes?.map(
        (participante) => participante.participante
      ) as [];
      reservacionForm.fecha_inicio = new Date(reservacion?.fecha_inicio as any);
      reservacionForm.fecha_fin = new Date(reservacion?.fecha_fin as any);

      setReservacionForm(reservacionForm);
      setIsInfo(true);
      setVisibleFormDialog(true);
    },
    [listaReservacion]
  );

  /**
   * Maneja el cambio de un evento (versión optimizada con useCallback)
   * @param {EventChangeArg} event - Información del cambio del evento
   */
  const handleEventChange = useCallback(
    (event: EventChangeArg) => {
      if (!event) return;

      setIsLoader(true);

      if (onVerificarTerminaFecha(event.event.end)) {
        setIsLoader(false);
        onRegresaEvent(
          event.event.id,
          event.oldEvent.startStr,
          event.oldEvent.endStr
        );
        return;
      }

      if (
        onVerificarFechas(
          event.event.start,
          event.event.end,
          event.event.id,
          event.event.extendedProps.espacioId
        )
      ) {
        setIsLoader(false);
        onRegresaEvent(
          event.event.id,
          event.oldEvent.startStr,
          event.oldEvent.endStr
        );
        return;
      }

      const reservacion = {
        ...listaReservacion.find((r) => r.id === parseInt(event.event.id)),
      };
      if (!reservacion) return;

      if (onVerificarEsPropio(reservacion)) {
        if (onVerificarFechaAnterior(event.event.start)) {
          setIsLoader(false);
          onToastError(
            "Error",
            "No se puede ingresar una fecha anterior a la actual."
          );
          onRegresaEvent(
            event.event.id,
            event.oldEvent.startStr,
            event.oldEvent.endStr
          );
          return;
        }

        let reservacionForm: ReservacionFormModel = reservacion as any;
        reservacionForm.espacio = reservacion.espacio?.id;
        reservacionForm.fecha_inicio = event.event.start;
        reservacionForm.fecha_fin = event.event.end;

        updateReservacionFormService(reservacionForm).then(
          (response: ResponseModel) => {
            if (response.status === 200) {
              onToastSuccess("Correcto", "Ha actualizado la reservación.");
              setIsLoader(false);
            } else {
              setIsLoader(false);
              onToastError(
                "Error",
                "No se puede guardar los participantes, intente mas tarde."
              );
            }
          }
        );
      } else {
        onRegresaEvent(
          event.event.id,
          event.oldEvent.startStr,
          event.oldEvent.endStr
        );
      }
    },
    [listaReservacion]
  );

  /**
   * Cierra el diálogo del formulario de reservación
   */
  const handleCloseFormDialog = () => {
    setVisibleFormDialog(false);
    setIsInfo(false);
  };

  return (
    <div className="h-full">
      <BlockUI blocked={isLoader}>
        {isLoader ? <Loader /> : null}
        <FormDialog
          isInfo={isInfo}
          visibleFormDialog={visibleFormDialog}
          listaEspacio={listaEspacio}
          listaAreaTrabajoSelect={listaAreaTrabajoSelect}
          setVisibleFormDialog={handleCloseFormDialog}
          reservacion={reservacionForm}
          onClickGuardaReservacion={onClickGuardaReservacion}
          onConfirmRemove={onConfirmRemoveSoft}
        />
        <div className="container imj-calendario-de-ocupacion text-center">
          <h1 className="mt-0">Reservación</h1>
          <div className="content-calendar">
            <FullCalendar
              ref={calendarComponentRef}
              events={listaEvent}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "customButton,dayGridMonth,timeGridWeek,timeGridDay",
              }}
              customButtons={{
                customButton: {
                  text: "Agregar",
                  click: function () {
                    // Aquí puedes agregar la lógica para el botón personalizado
                    let reservacion: ReservacionModel = new ReservacionModel();
                    reservacion.reservado_por = new UsuarioModel(loggedUser());
                    setVisibleFormDialog(true);
                    setReservacionForm(reservacion as any);
                  },
                },
              }}
              hiddenDays={[0, 6]}
              dayHeaderFormat={{
                weekday: "long",
              }}
              dayHeaderContent={onDayHeaderContent}
              buttonText={{
                today: "Hoy",
                month: "Mes",
                week: "Semana",
                day: "Dia",
              }}
              locale="es-mx"
              timeZone="local"
              editable={validateBtnEditar()}
              allDaySlot={false}
              selectable={validationCreate()}
              selectMirror={true}
              selectOverlap={false}
              slotDuration={"00:15:00"}
              snapDuration={"00:15:00"} //SI SON ADMINISTRADORES PUEDEN CREAR CUALQUIER DURACION
              selectMinDistance={10}
              select={onSelect}
              selectConstraint={{
                startTime: "07:00:00",
                endTime: "20:00:00",
              }}
              selectAllow={validateTimeSelection}
              eventContent={eventContent}
              eventTimeFormat={{
                hour: "numeric",
                minute: "2-digit",
                meridiem: false,
              }}
              eventChange={handleEventChange}
              eventColor="white"
              eventBackgroundColor="white"
              eventBorderColor="#e8474fc7"
              dayMaxEvents={true}
              dayMaxEventRows={1}
              displayEventEnd={true}
              weekNumbers={true}
              weekNumberFormat={{
                day: "2-digit",
                week: "long",
              }}
              eventOverlap={true}
              slotEventOverlap={false}
              eventClick={handleEventClick}
              height="100%"
              moreLinkText="mas"
              dateClick={onDateClick}
              selectLongPressDelay={2}
              slotMinTime="07:00:00"
              slotMaxTime="20:00:00"
              slotLabelInterval={"00:30:00"}
              slotLabelFormat={{
                hour: "numeric",
                minute: "2-digit",
                omitZeroMinute: false,
                meridiem: false,
              }}
            />
          </div>
        </div>
      </BlockUI>
    </div>
  );
};

export default CalendarioDeOcupacion;
